import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M4.693 2C3.206 2 2 3.206 2 4.695V7.389C2 7.884 2.401 8.287 2.898 8.287C3.394 8.287 3.795 7.884 3.795 7.389V4.695C3.795 4.2 4.197 3.796 4.693 3.796H7.387C7.883 3.796 8.285 3.394 8.285 2.898C8.285 2.403 7.883 2 7.387 2H4.693Z',
                    fill: '#E76B5F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M16.6108 2C16.1148 2 15.7148 2.403 15.7148 2.898C15.7148 3.394 16.1148 3.796 16.6108 3.796H19.3068C19.8018 3.796 20.2028 4.2 20.2028 4.695V7.389C20.2028 7.884 20.6048 8.287 21.1008 8.287C21.5968 8.287 21.9988 7.884 21.9988 7.389V4.695C21.9988 3.206 20.7928 2 19.3068 2H16.6108Z',
                    fill: '#E76B5F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M2 16.613V19.306C2 20.794 3.206 22 4.693 22H7.387C7.883 22 8.285 21.598 8.285 21.101C8.285 20.606 7.883 20.205 7.387 20.205H4.693C4.197 20.205 3.795 19.802 3.795 19.306V16.613C3.795 16.117 3.394 15.714 2.898 15.714C2.401 15.714 2 16.117 2 16.613Z',
                    fill: '#E76B5F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M20.2028 16.613V19.306C20.2028 19.802 19.8018 20.205 19.3068 20.205H16.6108C16.1148 20.205 15.7148 20.606 15.7148 21.101C15.7148 21.598 16.1148 22 16.6108 22H19.3068C20.7928 22 21.9988 20.794 21.9988 19.306V16.613C21.9988 16.117 21.5968 15.714 21.1008 15.714C20.6048 15.714 20.2028 16.117 20.2028 16.613Z',
                    fill: '#E76B5F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M13.4995 7.001C13.4995 6.72382 13.724 6.5 13.9995 6.5H17.1435C17.419 6.5 17.6435 6.72382 17.6435 7.001V10.143C17.6435 10.4202 17.42 10.643 17.1435 10.643H13.9995C13.723 10.643 13.4995 10.4202 13.4995 10.143V7.001Z',
                    fill: '#F7B1AB',
                    stroke: '#E76B5F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M6.49951 7.001C6.49951 6.72382 6.72398 6.5 6.99951 6.5H10.1435C10.419 6.5 10.6435 6.72382 10.6435 7.001V10.143C10.6435 10.4202 10.42 10.643 10.1435 10.643H6.99951C6.723 10.643 6.49951 10.4202 6.49951 10.143V7.001Z',
                    fill: '#F7B1AB',
                    stroke: '#E76B5F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M6.49951 14.001C6.49951 13.7238 6.72398 13.5 6.99951 13.5H10.1435C10.419 13.5 10.6435 13.7238 10.6435 14.001V17.143C10.6435 17.4202 10.42 17.643 10.1435 17.643H6.99951C6.723 17.643 6.49951 17.4202 6.49951 17.143V14.001Z',
                    fill: '#F7B1AB',
                    stroke: '#E76B5F',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M12.9995 15.5C12.9995 16.8802 14.1183 18 15.4995 18C16.8798 18 17.9995 16.8802 17.9995 15.5C17.9995 14.1198 16.8798 13 15.4995 13C14.1183 13 12.9995 14.1198 12.9995 15.5Z',
                    fill: '#F7B1AB',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const QrCodeColored = React.forwardRef(IconComponent);
QrCodeColored.displayName = 'QrCodeColored';

export { QrCodeColored };
